import { render } from "./DetailConfig.vue?vue&type=template&id=70b0d070"
import script from "./DetailConfig.vue?vue&type=script&lang=js"
export * from "./DetailConfig.vue?vue&type=script&lang=js"

import "./DetailConfig.vue?vue&type=style&index=0&id=70b0d070&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__